<template>

    <div class="fan-control">
    <div class="status">
      <div class="status-item">
        <el-button plain type="primary" @click="connectDevice" v-if="!connected" size="small">连接设备</el-button>
        <el-button plain type="danger" @click="disconnectDevice" v-if="connected" size="small">断开连接</el-button>
        
      </div>
    </div>

        <el-row :gutter="24">
          <el-col :span="4">
             <el-switch
              @change="saveCfg"
              v-model="smartMode0"          
              active-text="温控"
              inactive-text="手动"
              :disabled="!connected"
            />
            <div class="status-item">
              <label>转速：</label>
              <span>{{ fanSpeed0 }}</span>
            </div>
            <div class="status-item">
              <label>温度：</label>
              <span :style="{ color: tempColor0 }">{{ temperature0 }}°C</span>
            </div>
            <div class="fan-container">
              <div 
                class="fan"
                :style="fanStyle0"
              >
                <div class="blade"></div>
                <div class="blade"></div>
                <div class="blade"></div>
              </div>     
            </div>       
          </el-col>
          <el-col :span="20">
            <el-slider v-model="duty0" :step="10" show-stops />
            <el-row :gutter="24" style="height: 50px;" v-for="n in 4" v-bind:key="n">
               <el-col :span="4"><el-input-number style="width: 80px;" v-model="tempArray0[4-n]" :min="1" :max="90" size="small" controls-position="right">
                    <template #suffix>
                        <span>℃</span>
                    </template>
                </el-input-number></el-col>
               <el-col :span="18"><el-slider v-model="pwmArray0[4-n]" :step="10" show-stops /></el-col>
               <el-col :span="2"></el-col>
            </el-row>
            
          </el-col>
        </el-row>
        <el-divider />
         <el-row :gutter="24">
          <el-col :span="4">
             <el-switch
              @change="saveCfg"
              v-model="smartMode1"          
              active-text="温控"
              inactive-text="手动"
              :disabled="!connected"
            />
              <div class="status-item">
              <label>转速：</label>
              <span>{{ fanSpeed1 }}</span>
            </div>
            <div class="status-item">
              <label>温度：</label>
              <span :style="{ color: tempColor1 }">{{ temperature1 }}°C</span>
            </div>
            <div class="fan-container">
              <div 
                class="fan"
                :style="fanStyle1"
              >
                <div class="blade"></div>
                <div class="blade"></div>
                <div class="blade"></div>
              </div>     
            </div>
          </el-col>
          <el-col :span="20">            
            <el-slider v-model="duty1" :step="10" show-stops />
            <el-row :gutter="24" style="height: 50px;" v-for="n in 4" v-bind:key="n">
               <el-col :span="4"><el-input-number style="width: 80px;" v-model="tempArray1[4-n]" :min="1" :max="90" size="small" controls-position="right">
                    <template #suffix>
                        <span>℃</span>
                    </template>
                </el-input-number></el-col>
               <el-col :span="18"><el-slider v-model="pwmArray1[4-n]" :step="10" show-stops /></el-col>
               <el-col :span="2"></el-col>
            </el-row>
            <el-text class="mx-1" type="danger">智能温控，下面为低温，往上温度升高</el-text>            
          </el-col>
        </el-row>
        <el-divider />
         <el-row :gutter="24">
          <el-col :span="4">
            <span>两线风扇控制</span>
          </el-col>
          <el-col :span="20">
            <el-slider v-model="duty2" :step="10" show-stops />            
          </el-col>
        </el-row>
        <div>
          <el-button  @click="loadCfg" :disabled="!connected">取消</el-button>
          <el-button type="success" @click="saveCfg" :disabled="!connected">保存</el-button>
        </div>
    
  </div>

    
    <div class="service-control" v-if="connected && false">
      <div class="input-group">
        <label>服务UUID:</label>
        <input type="text" v-model="serviceUUID" placeholder="输入服务UUID">
      </div>
      
      <div class="input-group">
        <label>特征UUID:</label>
        <input type="text" v-model="characteristicUUID" placeholder="输入特征UUID">
      </div>

      <div class="command-section">
        <input type="text" v-model="command" placeholder="输入命令（十六进制）">
        <button @click="sendCommand" :disabled="!canSend">发送命令</button>
      </div>
    </div>

    <!-- <div class="logs">
      <h3>日志</h3>
      <div v-for="(log, index) in logs" :key="index" class="log-item">
        [{{ log.timestamp }}] {{ log.message }}
      </div>
    </div> -->
</template>
<script setup>
  import { ref, reactive, computed, onMounted } from 'vue'
  import { ElMessage } from 'element-plus'

  
const fanSpeed0 = ref(0)
const temperature0 = ref(25)
const fanSpeed1 = ref(0)
const temperature1 = ref(25)
  
const connected = ref(false)
const device = ref(null)
const pwm = ref(0)
let pwmChanged = false
const serviceUUID = ref('0000ffe0-0000-1000-8000-00805f9b34fb') // 默认心率服务
const characteristicUUID = ref('0000ffe1-0000-1000-8000-00805f9b34fb') // 默认心率测量特征
// 新增状态变量
const notificationUUID = ref('0000ffe4-0000-1000-8000-00805f9b34fb') // 示例UUID
const isSubscribing = ref(false)
const notificationCharacteristic = ref(null)


const smartMode = ref(false)
const pwmArray = ref([25,35,45,60])
const tempArray = ref([25,35,45,60])

const duty0 = ref(0)
const smartMode0 = ref(false)
const pwmArray0 = ref([25,35,45,60])
const tempArray0 = ref([25,35,45,60])

const duty1 = ref(0)
const smartMode1 = ref(false)
const pwmArray1 = ref([25,35,45,60])
const tempArray1 = ref([25,35,45,60])

const duty2 = ref(0)

const fanDuty0 = ref(0)
const dutyOptions = ref([0,10,20,30,40,50,60,70,80,90,100])

let   dutyChar = null

let server = null
let service = null 
let characteristic = null

const command = ref('')
// const logs = reactive([])

const deviceInfo = reactive({
  name: '',
  id: ''
})


// 风扇样式计算
const fanStyle0 = computed(() => ({
  animation: `spin ${calcDuration0.value}s linear infinite`,
  filter: `hue-rotate(${duty0.value * 3}deg)`
}))

const fanStyle1= computed(() => ({
  animation: `spin ${calcDuration0.value}s linear infinite`,
  filter: `hue-rotate(${duty0.value * 3}deg)`
}))

// 计算旋转速度（0%时停止）
const calcDuration0 = computed(() => {
  return fanSpeed0.value === 0 ? 0 : (2 - duty0.value/60)
})
const calcDuration1 = computed(() => {
  return fanSpeed1.value === 0 ? 0 : (2 - duty1.value/60)
})

// 温度颜色计算
const tempColor0 = computed(() => {
  if (temperature0.value < 40) return '#4CAF50'
  if (temperature0.value < 50) return '#FFC107'
  return '#F44336'
})

// 温度颜色计算
const tempColor1 = computed(() => {
  if (temperature1.value < 40) return '#4CAF50'
  if (temperature1.value < 50) return '#FFC107'
  return '#F44336'
})

// 计算属性
//const connectionStatus = computed(() => connected.value ? '已连接' : '未连接')
const canSend = computed(() => command.value.trim() !== '')

// const stringToUint8Array = (str)=>{
//         var arr = [];
//         for (var i = 0, j = str.length; i < j; ++i) {
//             arr.push(str.charCodeAt(i));
//         }
        
//         var tmpUint8Array = new Uint8Array(arr);
//         return tmpUint8Array
//     }
// 日志记录
const addLog = (message) => {
    console.log(message)
}

// 连接设备
const connectDevice = async () => {
  try {
    device.value = await navigator.bluetooth.requestDevice({
      acceptAllDevices: false,    
      optionalServices: [serviceUUID.value],
      filters: [ 
        { namePrefix: 'BLE' } 
      ]
    })
    
    deviceInfo.name = device.value.name
    deviceInfo.id = device.value.id
    
    device.value.addEventListener('gattserverdisconnected', disconnectHandler)
    
    server = await device.value.gatt.connect()
    connected.value = true
    addLog(`已连接至设备: ${device.value.name}`)

    service = await server.getPrimaryService(serviceUUID.value)
    dutyChar = await service.getCharacteristic(characteristicUUID.value)

    await loadCfg()


    startNotifications()
  } catch (error) {
    addLog(`连接失败: ${error}`)
  }
}

// 断开连接处理
const disconnectHandler = () => {
  connected.value = false
  deviceInfo.name = ''
  deviceInfo.id = ''
  fanSpeed0.value = 0
  fanSpeed1.value = 0
  addLog('设备已断开连接')
}

// 主动断开连接
const disconnectDevice = () => {
  if (device.value?.gatt.connected) {
    device.value.gatt.disconnect()
  }
  connected.value = false
}

// 发送命令
const sendCommand = async () => {
  try {
    //const server = await device.value.gatt.connect()
    //const service = await server.getPrimaryService(serviceUUID.value)
    //const characteristic = await service.getCharacteristic(characteristicUUID.value)
    
    // 将命令转换为ArrayBuffer
    const data = hexStringToArrayBuffer(command.value.trim())
    
    await dutyChar.writeValue(data)
    addLog(`命令已发送: ${command.value}`)
    command.value = ''
  } catch (error) {
    addLog(`发送失败: ${error}`)
  }
}

// 十六进制字符串转ArrayBuffer
const hexStringToArrayBuffer = (hex) => {
  hex = hex.replace(/\s/g, '')
  if (hex.length % 2 !== 0) throw new Error('无效的十六进制字符串')
  
  const buffer = new Uint8Array(hex.length / 2)
  for (let i = 0; i < hex.length; i += 2) {
    buffer[i/2] = parseInt(hex.substr(i, 2), 16)
  }
  return buffer
}



// 新增文本解析方法
// const arrayBufferToString = (buffer) => {
//   return new TextDecoder().decode(buffer)
// }

// 在handleNotifications中添加格式选择
const handleNotifications = (event) => {
  if( pwmChanged ){
    pwmChanged = false
    return
  }
  const value = event.target.value
  console.log(value)
  let mode0 = value.getUint8(0,true);
  let tmp0 = value.getInt32(1,true);
  let duty0 = value.getUint8(5,true);
  let rpm0 = value.getUint16(6,true);

  let mode1 = value.getUint8(8+0,true);
  let tmp1 = value.getInt32(8+1,true);
  let duty1 = value.getUint8(8+5,true);
  let rpm1 = value.getUint16(8+6,true);

  let duty2 = value.getUint8(16+5,true);

  fanSpeed0.value = rpm0
  temperature0.value = tmp0
  fanSpeed1.value = rpm1
  temperature1.value = tmp1

  // fanSpeed.value = value.getUint16(5,true);
  // if(pwm.value!= duty){
  //   pwm.value = duty
  // }
  //temperature.value = tmp


  console.log('data0',mode0,tmp0,duty0,rpm0)
  console.log('data1',mode1,tmp1,duty1,rpm1)
  console.log('data2',duty2)
  //let data = arrayBufferToString(value.buffer)
  //let json = JSON.parse(data)  
  //console.log('json',data)
 // addLog(`收到数据: ${data}`)
}

// 新增启用通知方法
const startNotifications = async () => {
  try {
  
    characteristic = await service.getCharacteristic(notificationUUID.value)

    if (!characteristic.properties.notify) {
      throw new Error('该特征不支持通知功能')
    }

    await characteristic.startNotifications()
    characteristic.addEventListener('characteristicvaluechanged', handleNotifications)
    notificationCharacteristic.value = characteristic
    isSubscribing.value = true
    addLog('通知功能已启用')
  } catch (error) {
    addLog(`启用通知失败: ${error}`)
  }
}

// 新增停止通知方法
// const stopNotifications = async () => {
//   if (!notificationCharacteristic.value) return
  
//   try {
//     await notificationCharacteristic.value.stopNotifications()
//     notificationCharacteristic.value.removeEventListener(
//       'characteristicvaluechanged',
//       handleNotifications
//     )
//     isSubscribing.value = false
//     notificationCharacteristic.value = null
//     addLog('通知功能已停止')
//   } catch (error) {
//     addLog(`停止通知失败: ${error}`)
//   }
// }
// watch(pwm,(newVal,oldVal)=>{
  
//   if(oldVal!=newVal){
//     var buffer = new ArrayBuffer(1);
//     var x = new Uint8Array(buffer);
//     x[0] = newVal
//     console.log('pwm',newVal,oldVal);
//     //dutyChar.writeValue(buffer)
//   }
 
// })
const pwmChange = async (val)=>{   
    pwmChanged = true
    const chval = await dutyChar.readValue()    
    //var buffer = new ArrayBuffer(17);
    var x = new Uint8Array(chval.buffer);
    x[3] = val
    //console.log('pwm',chval,x);
    dutyChar.writeValue(chval)
}
const loadCfg = async ()=>{
  const chval = await dutyChar.readValue()
  let cfg = new Uint8Array(chval.buffer);
  console.log('loadcfg',cfg)
  smartMode0.value = (cfg[2]==2)
  duty0.value = cfg[3]
  for(let i=0;i<4;i++){
     tempArray0.value[i]= cfg[4+i] 
     pwmArray0.value[i]= cfg[8+i] 
  }

  smartMode1.value = (cfg[0+12] ==2)
  duty1.value = cfg[1+12]

  for(let i=0;i<4;i++){
     tempArray1.value[i] = cfg[12+2+i]
     pwmArray1.value[i] = cfg[12+6+i] 
  }

  duty2.value = cfg[1+22];
    // smartMode.value = (cfg[2]===2)
    // for(let i=0;i<4;i++){
    //   tempArray.value[i] = cfg[4+i]
    //   pwmArray.value[i] = cfg[8+i]
    // }
}
const saveCfg = async ()=>{
  const chval = await dutyChar.readValue()
  let cfg = new Uint8Array(chval.buffer);
  cfg[0] = 0x10;
  cfg[1] = 30;
  cfg[2] = smartMode0.value?2:1;
  cfg[3] = duty0.value;
  for(let i=0;i<4;i++){
      cfg[4+i] = tempArray0.value[i]
      cfg[8+i] = pwmArray0.value[i]
  }

  cfg[0+12] = smartMode1.value?2:1;
  cfg[1+12] = duty1.value;
  for(let i=0;i<4;i++){
      cfg[12+2+i] = tempArray1.value[i]
      cfg[12+6+i] = pwmArray1.value[i]
  }

  cfg[1+22] = duty2.value;

  console.log("saveCfg",cfg)

  // cfg[2] = smartMode.value?2:1
  //  for(let f = 0;f<3;f++){
  
  // }
  await dutyChar.writeValue(chval)
  ElMessage.success('保存成功')
}
onMounted(()=>{
    
})
</script>
<style scoped>
.device-info{
    width: 90%;
}

.fan-control {
  max-width: 1000px;
  margin: 2rem auto;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 10px;
  text-align: center;
}

.status {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}

.status-item {
  font-size: 1.2em;
}

.fan-container {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 10px auto;
}

.fan {
  width: 100%;
  height: 100%;
  position: relative;
  transition: filter 0.3s;
}

.blade {
  position: absolute;
  width: 20px;
  height: 50px;
  background: #607D8B;
  left: 50%;
  transform-origin: bottom;
  border-radius: 10px;
}

.blade:nth-child(1) { transform: translateX(-50%) rotate(0deg); }
.blade:nth-child(2) { transform: translateX(-50%) rotate(120deg); }
.blade:nth-child(3) { transform: translateX(-50%) rotate(240deg); }

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.controls {
  margin-top: 20px;
}

input[type="range"] {
  width: 80%;
  height: 10px;
  background: #ddd;
  border-radius: 5px;
}

.speed-percent {
  font-size: 1.5em;
  margin-top: 10px;
  color: #2196F3;
}


</style>